<template>
    <dialog-box @close="$emit('close')" title="Vulnerability Analytics" :width="'400px'" overlay>
        <p>Vulnerability segmentation and analytics are not enabled for your account.</p>
        <p><a :href="mailto">Click here</a> to email your DataEQ account director about enabling this feature.</p>
        <template v-slot:buttons>
            <section class="vuln-dialog-buttons">
                <be-button :primary="true" @click="$emit('close')">Ok</be-button>
            </section>
        </template>
    </dialog-box>
</template>

<script>
import DialogBox from '@/components/DialogBox';
import BeButton from '@/components/buttons/BeButton';
import VuexStore from '@/store/vuex/VuexStore';

export default {
    name: "VulnerabilityUnavailableDialog",
    components: { DialogBox, BeButton },
    computed: {
        cs() { return VuexStore.state.account?.clientService; },
        csName() { return this.cs?.firstName ? `${this.cs.firstName} ${this.cs.lastName}` : null; },
        mailto() {
            const account = VuexStore.state.account;
            const cc = this.cs?.email ? `&cc=${this.cs.email}` : '';
            const subject = encodeURIComponent(`${account?.code}: Vulnerability Analytics Enquiry`);
            const body = encodeURIComponent(
                `Hi,\n\nI'd like to find out more about enabling Vulnerability Analytics for our account.\n\nThanks`
            );
            return `mailto:support@dataeq.com?subject=${subject}${cc}&body=${body}`;
        }
    }
}
</script>

<style scoped>
.vuln-dialog-buttons {
    display: flex;
    justify-content: center;
}
</style>